<div class="w-100 h-100 proposal-details overflow-hidden d-flex flex-column align-items-start justify-content-between"
     *ngIf="{selectedProposal: (proposal$|async), loading:(loading$|async), rejectionId: rejectionId$|async} as proposal">
  <ng-container *ngIf="!proposal.loading;else loading">
    <div class="w-100 h-100 d-flex flex-shrink-1 flex-column">

      <div
        class="d-flex justify-content-start w-100 align-items-start mb-3 pe-3 align-text-bottom justify-content-between">
        <div class="main-title d-flex flex-column gap-3 mb-3">

          <span class="character-limit-fifty">
            <ng-container *ngIf="proposal.selectedProposal.proposalInformation.proposalName">
              {{proposal.selectedProposal.proposalInformation.proposalName}}
            </ng-container>
            <ng-container *ngIf="!proposal.selectedProposal.proposalInformation.proposalName">
              {{'proposal' | translate}}
            </ng-container>

          </span>
          <a class="nav-link d-flex blue-border w-fit-content"
             [href]="Route.PROPOSAL_DETAILS +'/' +proposal.selectedProposal.proposalInformation.id">{{"proposalDetails.toDetailPage"|translate}}
            <mat-icon>arrow_forward</mat-icon>
          </a>
          <span class="text gray">
        #{{proposal.selectedProposal.proposalInformation.id.slice(0, 8)}}
      </span>
        </div>
        <mat-icon class="main-blue cursor-pointer" (click)="deselectProposal()">close</mat-icon>

      </div>

      <ng-scrollbar visibility="hover" id="proposal-details-scrollbar"
                         class="proposal-details-content flex-shrink-1 flex-grow-1 pe-3">

        <div *ngIf="!(disablePartnerInfo$|async)" class="text mb-4">
          <span class="subtitle mb-2">{{'proposalDetails.partnerInformation'|translate}}</span>
          <div class="d-flex flex-column">
            <div class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.partnerName' | translate}}:</div>
              <div>{{proposal.selectedProposal.partner.name}}</div>
            </div>
            <div *ngIf="proposal.selectedProposal.partner.street !== '' || proposal.selectedProposal.partner.houseNumber !== ''" class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.streetNumber' | translate}}:</div>
              <div>{{proposal.selectedProposal.partner.street}}
                {{proposal.selectedProposal.partner.houseNumber}}
                <div>
                  {{proposal.selectedProposal.partner.addressSupplement}}
                </div>
              </div>
            </div>
            <div *ngIf="proposal.selectedProposal.partner.postalCode !== '' || proposal.selectedProposal.partner.location !== ''" class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.zipLocation' | translate}}:</div>
              <div>
                <div>{{proposal.selectedProposal.partner.postalCode}} {{proposal.selectedProposal.partner.location}}</div>
              </div>
            </div>

            <div *ngIf="proposal.selectedProposal.partner.countryCode !== ''" class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.lkz' | translate}}, {{'proposalDetails.country' | translate}}:</div>
              <div>
                <div>{{proposal.selectedProposal.partner.countryCode}}, {{'countryCodes.' + proposal.selectedProposal.partner.countryCode |translate }}</div>
              </div>
            </div>
          </div>
          <hr>
        </div>

        <div class="text mb-4">
          <span class="subtitle">{{'proposalDetails.theRisk'|translate}}</span>

          <div class="d-flex proposal-details-row" *ngIf="proposal.selectedProposal.proposalInformation.coveragePercentageRequested != null">
            <div class="info-col">
              {{'proposalDetails.requestedPercentage'|translate}}:
            </div>
            <div>
              {{proposal.selectedProposal.proposalInformation.coveragePercentageRequested + '%'}}
            </div>
          </div>

          <div class="d-flex proposal-details-row" *ngIf="proposal.selectedProposal.proposalInformation.coveragePercentageRequested != null">
            <div class="info-col">
              {{'proposalDetails.requestedRoles'|translate}}:
            </div>
            <div>
              {{(proposal.selectedProposal.proposalInformation.leadInsurerNeeded ?  'proposalDetails.leader' : '' )  | translate}}
              {{proposal.selectedProposal.proposalInformation.leadInsurerNeeded && proposal.selectedProposal.proposalInformation.followingInsurerNeeded ?  ', ' : '' }}
              {{(proposal.selectedProposal.proposalInformation.followingInsurerNeeded ?  'proposalDetails.follower' : '' )  | translate}}
            </div>
          </div>

          <div class="d-flex flex-column">
            <div class="d-flex proposal-details-row">
              <div class="info-col">
                {{'proposalDetails.begin'|translate}}:
                {{proposal.selectedProposal.proposalInformation.riskDateBegin | date: ('dateFormatShort' | translate)}} <span style="padding-left: 1.5vw">-</span>
              </div>
              <div>
                {{'proposalDetails.end'|translate}}: {{proposal.selectedProposal.proposalInformation.riskDateEnd | date: ('dateFormatShort' | translate)}}</div>
            </div>

            <div *ngIf="proposal.selectedProposal.proposalInformation.riskDescriptionFreeText" class="d-flex proposal-details-row">
              <div class="info-col">
                {{'proposalDetails.description'|translate}}:
              </div>
              <div>
                {{proposal.selectedProposal.proposalInformation.riskDescriptionFreeText}}
              </div>
            </div>
          </div>

          <div *ngIf="proposal.selectedProposal.proposalInformation.attachedFiles.length !== 0" class="d-flex proposal-details-row">
            <div class="info-col">{{'proposalDetails.files'|translate}}</div>
            <div>
              <div>{{proposal.selectedProposal.proposalInformation.attachedFiles.length}}</div>
            </div>
          </div>
          <hr>
        </div>

        <div class="text">
          <span class="subtitle">{{'proposalDetails.sums'|translate}}:</span>
          <div class="d-flex flex-column">
            <div *ngIf="proposal.selectedProposal.proposalInformation.insuredSumType" class="d-flex proposal-details-row">
              <div class="info-col">{{'createProposal.housingInsuranceSumType' | translate}}:</div>
              <div>{{'createProposal.housingInsuranceSumTypeOptions.' + proposal.selectedProposal.proposalInformation.insuredSumType | translate}}</div>
            </div>
            <div class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.sum'|translate}}:</div>
              <div>
                <ng-container *ngIf="proposal.selectedProposal.proposalInformation.insuredSumType === 'VALUES_1914'; else previewWithCurrency">
                  <div>{{proposal.selectedProposal.proposalInformation.insuredAmount | number}}</div>
                </ng-container>
                <ng-template #previewWithCurrency>
                  <div>{{proposal.selectedProposal.proposalInformation.insuredAmount | currency: proposal.selectedProposal.proposalInformation.currency}}</div>
                </ng-template>
              </div>
            </div>
            <div *ngIf="proposal.selectedProposal.proposalInformation.annualSalesAmount" class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.annualSalesAmount'|translate}}:</div>
              <div>
                <div>{{proposal.selectedProposal.proposalInformation.annualSalesAmount |currency:proposal.selectedProposal.proposalInformation.currency}}</div>
              </div>
            </div>
          </div>
          <hr>
        </div>

        <div class="text">
          <span class="subtitle">{{'proposalDetails.others'|translate}}:</span>
          <div class="d-flex flex-column">
            <div class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.internationalPrograms'|translate}}:</div>
              <div>
                <div>{{"proposalDetails." + (proposal.selectedProposal.proposalInformation.countriesWithLocalPolicies.length > 0 ? "yes" : "no") | translate}}</div>
              </div>
            </div>

            <div class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.previousDamages'|translate}}:</div>
              <div>
                <div>{{"proposalDetails." + (proposal.selectedProposal.previousDamages.length > 0 ? "yes" : "no") | translate}}</div>
              </div>
            </div>

            <div class="d-flex proposal-details-row">
              <div class="info-col">{{'proposalDetails.privateProposal'|translate}}:</div>
              <div>
                <div>{{"proposalDetails." + (proposal.selectedProposal.proposalInformation.privateProposal ? "yes" : "no") | translate}}</div>
              </div>

            </div>
          <div class="d-flex flex-column">
            <div class="d-flex proposal-details-row">
                <div class="private-list">
                  <ul>
                    <li *ngFor="let user of usersAllowedToView$|async">
                      {{user.company.name}} - <span class="username">{{user.firstName}} {{user.lastName}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
    <div @empty *ngIf="permissionService.canCreateOfferForProposal(proposal.selectedProposal.proposalInformation.coverage, proposal.selectedProposal.proposalInformation.deadline) &&
                       (this.activeUserId$|async) !== proposal.selectedProposal.creator.id && (proposal.selectedProposal.proposalInformation.usersAllowedToView.length === 0 || proposal.selectedProposal.proposalInformation.usersAllowedToView.includes((this.activeUserId$ | async)))"
         class="floating-container overflow-hidden">
      <div @buttonsContainer *ngIf="!showRejectionReason "
           class="w-100 d-flex flex-column pb-1">

        <div class="buttons">
          <ng-container *ngIf="(showRetractRejection$ | async)">
            <button class="blue-content"
                    (click)="retractRejection(proposal.rejectionId, proposal.selectedProposal.proposalInformation.id)">
              <span class="cursor-pointer">
                {{'proposalDetails.retractRejection'|translate}}
              </span>
            </button>
          </ng-container>
          <ng-container *ngIf="!(showRetractRejection$ | async)">
            <button class="blue-border" *ngIf="showRejection$|async"
                    (click)="showRejectionReasonField()">
              <img class="me-2" src="assets/svg-icons/disabled.svg" alt=""/>
              <span class="cursor-pointer">
                {{'proposalDetails.rejectionReason.rejectInsuranceContract'|translate}}
              </span>
            </button>
            <button class="blue-content"
                    (click)="navigateToCreateOffer(proposal.selectedProposal.proposalInformation.id)">
              <span class="cursor-pointer me-2">
                {{'proposalDetails.createOffer'|translate}}
              </span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </ng-container>

        </div>
      </div>
      <div @rejectionBox *ngIf="showRejectionReason"
           class="reject-reason-container ">
        <div [formGroup]="formGroup"
             class=" w-100 d-flex flex-column pb-1">

          <div class="rejection-reason-container">
            <div class="title mb-3">
              {{'proposalDetails.rejectionReason.title'|translate: {proposalName: (proposal$|async).proposalInformation.proposalName ?? ''} }}
            </div>

            <app-input-field class="field-container"
                             [label]="'proposalDetails.rejectionReason.subtitle'|translate">
        <textarea formControlName="rejectionReason"
                  class="input input-text-area" cdkTextareaAutosize
                  [placeholder]="'proposalDetails.rejectionReason.placeholder'|translate"
                  [cdkAutosizeMinRows]="5"> </textarea>
            </app-input-field>

            <div class="rejection-reason-button">
              <button class="reject-button"
                      (click)="showRejectionReasonField()">
                <span class="cursor-pointer">
                  {{'proposalDetails.rejectionReason.close'|translate}}
                </span>
              </button>
              <button class="blue-content"
                      (click)="updateRejectionReason(proposal.rejectionId)">
                <span class="cursor-pointer">
                  {{'proposalDetails.rejectionReason.rejectInsuranceContract'|translate}}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </ng-container>
</div>
<ng-template #loading>
  <div class="d-flex w-100 h-100 align-items-center justify-content-center">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>
